export default __webpack_public_path__ + "static/media/tituloEN.5d80c035.png";